import React from 'react';
import FeatureIntro from './components/FeatureIntro';
import FeatureCard from './components/FeatureCard';
import styles from './FeaturesSection.module.css';
import cardStyles from './components/FeatureCard.module.css';

const FeaturesSection = () => {
    return (
        <section className={styles.featuresSection}>
            <div className={styles.backgroundOverlay}>
                <div className={styles.backgroundBlack}></div>
                <div className={styles.backgroundContent}></div>
            </div>
            <FeatureIntro />
            {/* Card 01 - Birthdays - ORANGE - ALL WHITE TEXT */}
            <FeatureCard
                containerVariant={`${styles.rowEnd3RowStart2} ${cardStyles.topSpacing} ${styles.mdRowEnd2RowStart1}`}
                innerContainerVariant=""
                backgroundVariant={`${cardStyles.mdJustifySelfCenter} ${cardStyles.mdMt24_7812}`}
                contentContainerVariant={`${cardStyles.orangeBg} ${cardStyles.contentBackground}`}
                number="01"
                numberClassName="text-white"
                title="Birthdays"
                titleClassName="text-white"
                description="Get personalized video"
                descriptionClassName="text-white"
                descriptionSpanClassName="caret-transparent break-words font-wix_madefor_text_v2 font-medium"
            />
            {/* Card 02 - Fantasy Football - WHITE - ALL DARK TEXT */}
            <FeatureCard
                containerVariant={`${styles.rowEnd4RowStart3} ${styles.mdRowEnd3RowStart2}`}
                innerContainerVariant=""
                backgroundVariant={cardStyles.mdJustifySelfEnd}
                contentContainerVariant={`${cardStyles.whiteBg} ${cardStyles.contentBackground}`}
                number="02"
                numberClassName="text-black"
                title="Fantasy Football"
                titleClassName="text-black"
                description="Roast your competition"
                descriptionClassName="text-black"
                descriptionSpanClassName="text-black"
            />
            {/* Card 03 - Holiday Specials - ORANGE - ALL WHITE TEXT */}
            <FeatureCard
                containerVariant={`${styles.rowEnd5RowStart4} ${styles.mdRowEnd4RowStart3}`}
                innerContainerVariant=""
                backgroundVariant={cardStyles.mdJustifySelfCenter}
                contentContainerVariant={`${cardStyles.orangeBg} ${cardStyles.contentBackground}`}
                number="03"
                numberClassName="text-white"
                title="Holiday Specials"
                titleClassName="text-white"
                description="Videos for every season"
                descriptionClassName="text-white"
                descriptionSpanClassName="caret-transparent break-words font-wix_madefor_text_v2 font-medium"
            />
            {/* Card 04 - Trending Stars - WHITE - ALL DARK TEXT */}
            <FeatureCard
                containerVariant={`${styles.rowEnd6RowStart5} ${styles.mdRowEnd5RowStart4}`}
                innerContainerVariant=""
                backgroundVariant={cardStyles.mdJustifySelfEnd}
                contentContainerVariant={`${cardStyles.whiteBg} ${cardStyles.contentBackground}`}
                number="04"
                numberClassName="text-black"
                title="Trending Stars"
                titleClassName="text-black"
                description="Discover the stars"
                descriptionClassName="text-black"
                descriptionSpanClassName="text-black"
            />
        </section>
    );
};

export default FeaturesSection;